import { Component, OnInit } from '@angular/core';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { SystemNotificationsServiceDataProvider } from '@services/system-notifications/system-notifications.service';
import {
	SystemNotificationsButton,
	SystemNotificationsData,
	SystemNotificationsEvents
} from '@models/system-notifications.model';

@Component({
	selector: 'notification-bar',
	template: require('./notification-bar.html'),
	styles: [require('./notification-bar.scss')],
	providers: [
		{
			provide: CarouselConfig,
			useValue: { interval: 30000, noPause: false, showIndicators: false }
		}
	]
})
export class NotificationBarComponent implements OnInit {
	systemNotificationsData: Array<SystemNotificationsEvents> = null;
	actionList: Array<string> = [];
	disableButton: boolean;
	isShowNotificationBar = false;
	lastSystemNotificationId: string;
	epochSecondsFromBackend: number;
	timeDifference: number;
	timeoutID: number;
	headerFantomBlock;
	mobileHeaderFantomBlock;
	serverEvents;

	constructor(
		private systemNotificationsService: SystemNotificationsServiceDataProvider
	) {
		this.systemNotificationsService.systemNotificationChanged.subscribe(
			(data: SystemNotificationsData) => {
				this.updateSystemNotificationData(data);
			}
		);
	}

	ngOnInit(): void {
		this.getSystemNotificationData();
	}

	reactToButtonClick(action: SystemNotificationsButton, eventId: string) {
		if (action.type === 'ONE_TIME') {
			this.isShowNotificationBar = false;
			this.sendSystemNotificationRequest('ONE_TIME', eventId);
		} else if (action.type === 'PAGE_RELOAD') {
			this.sendSystemNotificationRequest('PAGE_RELOAD', eventId);
		}
	}

	sendSystemNotificationRequest(actionName: string, eventId: string) {
		this.systemNotificationsService
			.sendSystemNotificationsId(eventId)
			.subscribe((): void => {
				if (actionName === 'ONE_TIME') {
					this.getSystemNotificationData();
				} else if (actionName === 'PAGE_RELOAD') {
					window.location.reload();
				}
			});
	}

	private localTimeWithOffset() {
		return Math.round(Date.now() / 1000) + this.timeDifference;
	}

	isRelevant(
		fromEpochSeconds: number,
		toEpochSeconds: number,
		localTime: number
	) {
		if (fromEpochSeconds !== null && toEpochSeconds !== null) {
			return fromEpochSeconds <= localTime && localTime < toEpochSeconds;
		}
		if (fromEpochSeconds === null && toEpochSeconds !== null) {
			return localTime < toEpochSeconds;
		}
		if (fromEpochSeconds !== null && toEpochSeconds === null) {
			return fromEpochSeconds <= localTime;
		}
		return true;
	}

	maxTime(minTime: number, data: Array<number>): number {
		let result: number = null;
		for (const time of data) {
			if (
				time !== null &&
				time > minTime &&
				(result === null || result > time)
			) {
				result = time;
			}
		}
		return result;
	}

	private renderBannerEvents() {
		if (this.timeoutID !== null) {
			clearTimeout(this.timeoutID);
			this.timeoutID = null;
		}

		this.systemNotificationsData = null;
		if (this.serverEvents && this.serverEvents.length) {
			const localTime: number = this.localTimeWithOffset();
			let minTime: number = null;
			this.systemNotificationsData = this.serverEvents.reduce((total, next) => {
				minTime = this.maxTime(localTime, [
					next.validFromEpochSeconds,
					next.validTillEpochSeconds,
					minTime
				]);
				if (
					this.isRelevant(
						next.validFromEpochSeconds,
						next.validTillEpochSeconds,
						localTime
					)
				) {
					if (next.actions === null) {
						total.push(next);
					} else {
						for (const actionName of this.systemNotificationsService.createActionList(
							next.actions
						)) {
							const actionMethod: string = next.actions[actionName].method;
							if (
								(actionName === 'ONE_TIME' || actionName === 'PAGE_RELOAD') &&
								actionMethod === 'MANUAL'
							) {
								next.actionButton = {
									type: actionName,
									action: next.actions[actionName]
								};
								total.push(next);
							}
						}
					}
				}
				return total;
			}, []);

			if (minTime !== null) {
				this.timeoutID = setTimeout(
					() => this.renderBannerEvents(),
					(minTime - this.localTimeWithOffset()) * 1000 + 100
				);
			}
		}

		if (
			this.systemNotificationsData !== null &&
			this.systemNotificationsData.length > 0
		) {
			this.isShowNotificationBar = true;
			this.headerFantomBlock.classList.add('show-header-fantom-block');
			this.mobileHeaderFantomBlock.classList.add('mobile-banner-indentations');
		} else {
			this.isShowNotificationBar = false;
			this.headerFantomBlock.classList.remove('show-header-fantom-block');
			this.mobileHeaderFantomBlock.classList.remove(
				'mobile-banner-indentations'
			);
		}
	}

	private updateSystemNotificationData(data: SystemNotificationsData): void {
		this.headerFantomBlock = document.querySelector('#header-fantom-block');
		this.mobileHeaderFantomBlock = document.querySelector(
			'.mobile-banner-styles'
		);
		this.systemNotificationsData = null;
		this.timeDifference = 0;

		if (data && data.events && data.events.length) {
			this.timeDifference = data.epochSeconds - Math.round(Date.now() / 1000);
			this.serverEvents = data.events;
			this.renderBannerEvents();
		} else {
			this.serverEvents = null;
			this.renderBannerEvents();
		}
	}

	private getSystemNotificationData(): void {
		this.systemNotificationsService
			.fetchSystemNotificationsData()
			.subscribe((data: SystemNotificationsData): void => {
				this.updateSystemNotificationData(data);
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/notification-bar/notification-bar.ts